/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockReportItemCtrl
 */
angular.module('mercury.modules.stock.report')
.controller('StockReportItemCtrl', ["$filter", "$q", "reporttime", "$scope", "$stateParams", "StockItems", "StockItemGroups", "title", "StockReceived", function($filter, $q, reporttime, $scope, $stateParams, StockItems, StockItemGroups, title, StockReceived) {
  title.set('Orders By Item');

  reporttime.defaultType = 'week';

  $scope.showUnpurchased = false;
  $scope.expandAll = false;
  $scope.reportTime = $stateParams.report;

  $scope.purchaseOrderConditionId = 0;
  $scope.purchaseOrderConditions = [
    {id: 0, filterText: 'Received', propertyName: 'receivedAt', label: 'Stock Received Date'},
    {id: 1, filterText: 'Invoiced', propertyName: 'invoicedAt', label: 'Invoice Date'}
  ];

  $scope.getCurrentPurchaseOrderCondition = function() {
    return $scope.purchaseOrderConditions.find(function(type) {
      return type.id === $scope.purchaseOrderConditionId;
    }) || {};
  };

  $scope.items = StockItems.getAllStockApi(reporttime.start());
  $scope.itemGroups = StockItemGroups.getAllSubcategories();
  
  $scope.stockReceiveds = StockReceived.getStockReceivedsByDateRange(
    reporttime.start(),
    reporttime.end(),
    $scope.getCurrentPurchaseOrderCondition().filterText
  ) 

  /**
   * Iterates over data retrieved from multiple API calls and constructs objects
   * suitable for presentation of the report in the UI.
   */
  function prepareReportData() {
    // Get all order lines into a object keyed by the stock item id.
    var orderLinesGrouped = {};

    const stockReceivedLines = $scope.stockReceiveds.reduce((lines, stockReceived) => (
      lines.concat(stockReceived.lines.map(line => (
        // We are using Object.assign here as the ngAnnotate step of AngularJS pipeline
        // doesnt understand spread operators (e.g. '...line').
        Object.assign(
          {},
          line,
          {
            parentId: stockReceived.id,
            creditRequest: stockReceived.creditRequest,
            referenceNumber: stockReceived.type == 'Invoice' 
              ? stockReceived.invoiceNumber
              : stockReceived.purchaseOrderNumber,
            receivedAt: stockReceived.receivedAt,
            orderedAt: stockReceived.orderedAt,
            invoicedAt: stockReceived.invoicedAt,
            type: stockReceived.type
          }
        )
      )))
    ), [])

    stockReceivedLines.forEach(line => {
      if (!orderLinesGrouped[line.itemId]) {
        orderLinesGrouped[line.itemId] = [];
      }
      orderLinesGrouped[line.itemId].push(line)
    })

    var groupedItems = {};
    var stockItemToGroupId = {};
    angular.forEach($scope.items, function(item) {
      if (!groupedItems[item.groupId]) {
        groupedItems[item.groupId] = [];
      }

      stockItemToGroupId[item.id] = item.groupId;

      var itemSection = {
        item: item,
        itemTotalCost: 0,
        itemTotalQuantity: 0,
        orders: []
      };

      if (orderLinesGrouped[item.id]) {
        angular.forEach(orderLinesGrouped[item.id], function(order) {
          itemSection.orders.push(order);
          itemSection.itemTotalQuantity += order.quantityReceived;
          itemSection.itemTotalCost += order.quantityReceived * order.unitCost;
        });
      }

      groupedItems[item.groupId].push(itemSection);
    });

    // Create a list of promises getting data for stock items which are deleted
    // and need to be retrieved individually.
    var missingStockItemPromises = [];
    Object.keys(orderLinesGrouped).forEach(function(stockItemId) {
      if (!stockItemToGroupId[stockItemId]) {
        missingStockItemPromises.push(
          StockItems.getStockApi(stockItemId, true).$promise
        );
      }
    });

    // Once we've got all the missing stock promises we continue with preparing
    // the data for display.
    $scope.loading = $q.all(missingStockItemPromises);
    $scope.loading.then(function(missingStockItems) {

        // Bucket up the purchase orders that are attached to deleted stock items.
        missingStockItems.forEach(function(item) {
          var itemSection = {
            item: item,
            itemTotalCost: 0,
            itemTotalQuantity: 0,
            orders: []
          };

          angular.forEach(orderLinesGrouped[item.id], function(order) {
            itemSection.orders.push(order);
            itemSection.itemTotalQuantity += order.quantityReceived;
            itemSection.itemTotalCost += order.quantityReceived * order.unitCost;
          });

          if (!groupedItems[item.groupId]) {
            groupedItems[item.groupId] = [];
          }
          groupedItems[item.groupId].push(itemSection);
        });

        var superGroups = {};
        angular.forEach($scope.itemGroups, function(itemGroup) {
          if (!superGroups[itemGroup.category.id]) {
            superGroups[itemGroup.category.id] = {
              superGroupName: itemGroup.category.name,
              superGroupTotalCost: 0,
              itemGroups: []
            };
          }

          var itemGroupSection = {
            itemGroupName: itemGroup.name,
            itemGroupTotalCost: 0,
            items: []
          };

          if (groupedItems[itemGroup.id]) {
            angular.forEach(groupedItems[itemGroup.id], function(item) {
              itemGroupSection.items.push(item);
              itemGroupSection.itemGroupTotalCost += item.itemTotalCost;
            });
          }

          superGroups[itemGroup.category.id].superGroupTotalCost += itemGroupSection.itemGroupTotalCost;
          superGroups[itemGroup.category.id].itemGroups.push(itemGroupSection);
        });

        $scope.report = [];
        $scope.reportTotal = 0;
        angular.forEach(superGroups, function(superGroup) {
          var activeItemGroups = [];
          angular.forEach(superGroup.itemGroups, function(itemGroup) {
            if (itemGroup.items.length > 0) {
              activeItemGroups.push(itemGroup);
            }
          });
          superGroup.itemGroups = activeItemGroups;

          if (superGroup.itemGroups.length > 0) {
            $scope.report.push(superGroup);
            $scope.reportTotal += superGroup.superGroupTotalCost;
          }
        });
        $scope.report = $filter('orderBy')($scope.report, 'superGroupName');

        $scope.changeShowUnpurchased();
      });
  }

  $scope.loading = $q.all([$scope.items.$promise, $scope.stockReceiveds.$promise, $scope.itemGroups.$promise]);
  $scope.loading.then(prepareReportData);

  $scope.changeShowUnpurchased = function() {
    angular.forEach($scope.report, function(superGroup) {
      superGroup.hide = true;

      angular.forEach(superGroup.itemGroups, function(itemGroup) {
        itemGroup.hide = true;

        angular.forEach(itemGroup.items, function(item) {
          item.hide = !(item.orders.length > 0 || $scope.showUnpurchased);

          if (!item.hide) {
            superGroup.hide = false;
            itemGroup.hide = false;
          }
        });
      });
    });
  };

  $scope.print = function() {
    window.print();
  };

  $scope.changeExpandAll = function() {
    angular.forEach($scope.report, function(superGroup) {
      angular.forEach(superGroup.itemGroups, function(itemGroup) {
        angular.forEach(itemGroup.items, function(item) {
          item.open = $scope.expandAll && item.orders.length > 0;
        });
      });
    });
  };

  $scope.setPurchaseOrderCondition = function(id) {
    $scope.purchaseOrderConditionId = id;

    const reportType = reporttime.reportType();
    const filterText = $scope.getCurrentPurchaseOrderCondition().filterText;
    const start = reporttime.start();

    // If we filter by Invoiced and the report type is day, we need to get the stock received items for the day
    // and not for a date range as the InvoicedAt(or IssuedAt) is a DateOnly and not a DateTimeOffset
    if(reportType === 'day' && filterText === 'Invoiced') {
      $scope.stockReceiveds = StockReceived.getStockReceivedsByDateRange(
        start,
        start,
        filterText
      )
    } else {
      $scope.stockReceiveds = StockReceived.getStockReceivedsByDateRange(
        start,
        reporttime.end(),
        filterText
      )
    }

    $scope.loading = $q.all([$scope.stockReceiveds.$promise]);
    $scope.loading.then(prepareReportData);
  };

  $scope.extractItemExpandData = (order) => {
    const orderDate = moment(order[$scope.getCurrentPurchaseOrderCondition().propertyName]).format('MMM DD, YYYY')
    let referenceNumber = order.referenceNumber
    let orderType = 'Purchase Order'

    if (order.type === 'Invoice') {
      orderType = 'Invoice'
    }

    // If the Purchase Order or invoice is a Credit Request
    if (order.creditRequest) {
      orderType = 'Credit Request'
    }

    return `${orderDate} - ${orderType} #${referenceNumber}`
  }
}]);
